const toKilogramMultiplers: {[key in MassUnit]: number} = {
 "kg": 1,
 "t":  1000,
 "lb": 0.45359237,
}

export type MassUnit = "kg" | "t" | "lb";

const MASS_UNITS: MassUnit[] = ["kg", "t", "lb"];

const convert = (amount: number, from: MassUnit, to: MassUnit) => {
    const mFrom = toKilogramMultiplers[from.toLowerCase() as MassUnit];
    const mTo = toKilogramMultiplers[to.toLowerCase() as MassUnit];
    return amount * mFrom / mTo;
}

export {MASS_UNITS,convert}
